/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Order_Carrier_Mark_Delivery_Failed_SuccessInputs */

const vi_toast_order_carrier_mark_delivery_failed_success = /** @type {(inputs: Toast_Order_Carrier_Mark_Delivery_Failed_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đánh dấu giao thất bại`)
};

/**

* @param {Toast_Order_Carrier_Mark_Delivery_Failed_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_order_carrier_mark_delivery_failed_success = /** @type {((inputs?: Toast_Order_Carrier_Mark_Delivery_Failed_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Order_Carrier_Mark_Delivery_Failed_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_order_carrier_mark_delivery_failed_success(inputs)
});